<template>
    <div class="signup">
        <div class="form">
            <h2>Maak een account aan voor uw bedrijf</h2>
            <div class="form-row mt-3">
                <div class="form-group col-md-6">
                    <input type="text" class="form-control" name="input[Voornaam]"
                           :class="{invalid: $v.voornaam.$invalid}" @change="$v.voornaam.$touch()"
                           placeholder="Voornaam"
                           v-model="voornaam">
                    <div v-if="$v.voornaam.$error">
                        <p class="help text-danger" v-if="!$v.voornaam.required">
                            Veld is vereist</p>
                        <p class="help text-danger" v-if="!$v.voornaam.minLength">
                            Veld is vereist</p>
                    </div>
                </div>
                <div class="form-group col-md-6">
                    <input type="text" class="form-control" name="input[Achternaam]" placeholder="Achternaam"
                           v-model="achternaam" :class="{invalid: $v.achternaam.$invalid}"
                           @change="$v.achternaam.$touch()">
                    <div v-if="$v.achternaam.$error">
                        <p class="help text-danger" v-if="!$v.achternaam.required">
                            Veld is vereist</p>
                        <p class="help text-danger" v-if="!$v.achternaam.minLength">
                            Veld is vereist</p>
                    </div>
                </div>
            </div>

            <div class="alert alert-danger" v-if="errorMessage">{{errorMessage}}</div>

            <div class="form-row">
                <div class="form-group col-md-12">

                    <input type="email" class="form-control" name="input[Email]" id="exampleInputEmail1"
                           placeholder="Email adres" v-model="email" :class="{invalid: $v.email.$invalid}"
                           @change="$v.email.$touch()">

                    <div v-if="$v.email.$error">
                        <div class="clearfix"></div>
                        <p class="help text-danger" v-if="!$v.email.required">
                            Veld is vereist</p>
                        <p class="help text-danger" v-if="!$v.email.email">
                            Veld moet een geldig email adres zijn</p>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-md-12">
                    <input type="password" class="form-control" name="input[Wachtwoord]" id="exampleInputPassword1"
                           placeholder="Wachtwoord" v-model="wachtwoord" :class="{invalid: $v.wachtwoord.$invalid}"
                           @change="$v.wachtwoord.$touch()">

                    <div v-if="$v.wachtwoord.$error">
                        <div class="clearfix"></div>
                        <p class="help text-danger" v-if="!$v.wachtwoord.required">
                            Veld is vereist</p>
                        <p class="help text-danger" v-if="!$v.wachtwoord.minLength">
                            Wachtwoord moet minimaal 8 karakters bevatten</p>
                    </div>
                </div>
            </div>

            <div class="checkbox">

                <label for="input-terms" :class="{invalid: $v.voorwaarden.$invalid}">
                    <input type="checkbox" id="input-terms" name="input[voorwaarden]" v-model="voorwaarden"
                           @change="$v.voorwaarden.$touch()">
                    Ik accepteer <a href="#input-terms" @click="showModal('terms')">de algemene voorwaarden</a>
                    <div v-if="$v.voorwaarden.$error">
                        <p class="help text-danger">
                            U moet akkoord gaan met de voorwaarden om een account aan te kunnen maken
                        </p>
                    </div>
                </label>
            </div>
            <button type="submit" class="btn btn-primary my-3" @click="submit" v-if="!bLoading">Account Aanmaken</button>
            <div class="loader" id="loader-1" v-if="bLoading"></div>
            <div class="row">
                <div class="col-12 text-center mt-3">
                    Heeft u al een account? <a href="https://www.digiwallet.nl/nl/login">Log in</a>
                </div>
            </div>
        </div>
        <Modal v-if="bShowModal" :title="modalTitle" :url="modalUrl" v-on:closeModal="hideModal"/>
    </div>

</template>

<script>
  import Modal from './Modal.vue'
  import { validation } from '../mixins/account-validations'

  export default {
    name: 'Form',
    props: {
      msg: String
    },
    mixins: [validation],
    components: {
      Modal
    },
    data () {
      return {
        voornaam: '',
        achternaam: '',
        email: '',
        wachtwoord: '',
        voorwaarden: 0,
        bLoading: false,
        bShowModal: false,
        bValidated: false,
        modalTitle: '',
        modalUrl: '',
        errorMessage: null
      }
    },
    methods: {
      hideModal () {
        this.bShowModal = false
        this.modalTitle = ''
        this.modalUrl = ''
      },
      showModal (modal) {
        if (modal === 'terms') {
          this.bShowModal = true
          this.modalTitle = 'Algemene Voorwaarden'
          this.modalUrl = 'https://www.digiwallet.nl/nl/terms?standalone=0'
        }
      },
      requestFailed (e) {
        this.bLoading = false
        if (e && e.data) {
          return alert(e.data)
        }
        alert('an error occured while processing the request: ' + e)
      },
      submit () {
        this.bLoading = true
        this.errorMessage = ''
        const isValid = this.validate()
        if (isValid) {
          this.$http.post('/signup/wizard/create', {
            'SignupForm':
              {
                firstname: this.voornaam,
                lastname: this.achternaam,
                email: this.email,
                password: this.wachtwoord,
                terms: this.voorwaarden,
              }
          })
            .then(request => this.parseSignupResponse(request))
            .catch(() => this.requestFailed())
        }
      },
      parseSignupResponse (req) {
        if (req.status !== 200) {
          this.requestFailed(req)
          return false
        }
        if (typeof req.data === 'object') {
          let arr = Object.values(req.data)
          this.errorMessage = arr[0]
          this.bLoading = false
        } else if (typeof req.data === 'number') {
          this.$store.commit('setUserId', req.data)
          this.$emit('accountCreated')
        } else {
          this.bLoading = false
          alert('unknown response type ' + typeof req.data)
        }
      },
      validate () {
        this.$v.$touch()
        let isValid = true

        this.fields.forEach((field) => {
          if (this.$v[field].$invalid) {
            isValid = false
            this.bLoading = false
          }
        })

        return isValid
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .signup {
        margin: auto auto;
        max-width: 480px;
    }

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .checkbox {
        margin-bottom: 14px;

        .help {
            margin-top: 14px;
        }
    }

    .help {
        margin: 0 0 5px 0;
        font-size: 0.95rem;
    }

    #exampleInputEmail1 {
        width: 100%;
    }
</style>
